const state = {
  menuActive: -1
}

const mutations = {
  setMenuActive: (state, data) => {
    state.menuActive = data
  }
}

const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}